import React from 'react';
import { List } from 'immutable';
import c from 'classnames';
import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import InformationOverlay from '../../../InformationOverlay';

import './style.scss';

const WebformFieldset = (props) => {
  const { entity, WebformMapper } = props;
  const classNames = entity.getIn(['#attributes', 'class'], List());

  const wrapperClassNames = c('WebformFieldset',
    'RiskMonitorWebformFieldset',
    classNames.toJS(),
    `WebformFieldset--type-${entity.get('#format', '')}`,
  );
  const containerClassNames = c('webform-container', classNames.toJS());
  const key = entity.getIn(['#webform_key']);
  const description = entity.getIn(['#description'], null);
  const overlayTitle = entity.getIn(['#more_title'], null);
  const overlayBody = entity.getIn(['#more'], null);

  // Remove al non-element children.
  const children = entity.filter((_, k) => k.indexOf('#') === -1);

  // Recursively render children.
  return (
    <fieldset className={wrapperClassNames}>
      <div className="WebformFieldset__content">
        <legend>
          {entity.get('#title')}
          {overlayBody && (
            <InformationOverlay
              overlayKey={`FielsetOverlay__${key}`}
              title={overlayTitle}
              body={overlayBody}
            />
          )}
        </legend>
        {description && (
          <div className="WebformFieldset__content__description">
            <WysiwygField
              property="schema:text"
              html={description}
            />
          </div>
        )}
      </div>
      <div className={containerClassNames}>
        <WebformMapper {...props} entities={children} />
      </div>
    </fieldset>
  );
};

export default WebformFieldset;
